// Pure helper answering "is the browser currently on one of the public
// (token-link) form pages?" — the pages a referee/candidate lands on from
// an emailed or texted link, with no account or login involved. Lives in
// repo-root shared so both the global HTTP interceptor and the per-project
// app components can use it.
//
// The match is anchored and requires a token segment, so protected routes
// that nest the same words deeper (/dashboard/references,
// /candidates/:id/references) never match.
const PUBLIC_FORM_PATH =
  /^\/(references|reference-requests|verification-requests|permissions|signatures|forms)\/[^/]+/;

export function isPublicFormPath(
  pathname: string = window.location.pathname
): boolean {
  return PUBLIC_FORM_PATH.test(pathname);
}
